import { Button } from '@strata/react-buttons';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

export const ListPageHeader = ({ pageTitle, buttons = undefined, rightContent = undefined }) => {
    const navigate = useNavigate();
    return (
        <div className="sds_list-page__header">
            <div className="sds_list-page__header__title">{pageTitle}</div>
            {(buttons?.length > 0 || rightContent) && (
                <div className="sds_list-page__header__right-container">
                    {rightContent}
                    {buttons?.map((button) => (
                        <Button
                            key={button.label}
                            intent={button.intent ?? Button.Intent.PRIMARY}
                            label={button.label}
                            disabled={button.disabled}
                            type={button.type}
                            onClick={() => {
                                if (button.onClick) {
                                    button.onClick();
                                } else if (button.path) {
                                    navigate(button.path);
                                }
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

ListPageHeader.propTypes = {
    pageTitle: PropTypes.string.isRequired,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            intent: PropTypes.oneOf(Object.values(Button.Intent)),
            path: PropTypes.string,
            onClick: PropTypes.func,
            disabled: PropTypes.bool,
            type: PropTypes.oneOf(['button', 'submit', 'reset']),
        }),
    ),
    rightContent: PropTypes.node,
};
